import React from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Textarea } from './ui/Textarea';
import { AnimateOnScroll } from './AnimateOnScroll';
import { ChevronDown } from 'lucide-react';
export function ContactForm() {
  return <section className="bg-black py-24 lg:py-32 relative overflow-hidden" data-id="element-681">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-682">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-683">
          {/* Left Column - Image & Artistic Elements */}
          <AnimateOnScroll className="w-full lg:w-[40%] relative" data-id="element-684">
            <div className="relative" data-id="element-685">
              <img src="https://cdn.magicpatterns.com/uploads/sJBEdPwnCiw3TEJMeAJisd/Group_196.png" alt="Close up portrait with artistic Be Excellent text" className="w-full h-auto object-contain" data-id="element-686" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Form Card */}
          <AnimateOnScroll className="w-full lg:w-[60%]" delay={200} data-id="element-687">
            <div className="bg-white rounded-lg border-[5px] border-[#FF1493] p-8 lg:p-12" data-id="element-688">
              <div className="text-center mb-8" data-id="element-689">
                <h2 className="text-3xl lg:text-4xl font-bold uppercase mb-4 text-black leading-tight font-[Poppins,_sans-serif]" data-id="element-690">
                  START YOUR
                  <br data-id="element-691" />
                  TRANSFORMATION TODAY
                </h2>
                <p className="text-gray-600 text-sm lg:text-base leading-relaxed max-w-lg mx-auto font-[Poppins,_sans-serif]" data-id="element-692">
                  Ready to unveil the best version of yourself? Begin your
                  journey with Be CLINICAL and let our team of experts guide you
                  towards achieving your beauty and wellness goals. Schedule
                  your consultation now and take the first step towards a more
                  confident, radiant you.
                </p>
              </div>

              <form className="space-y-4" data-id="element-693">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-694">
                  <Input placeholder="First Name*" required data-id="element-695" />
                  <Input placeholder="Last Name*" required data-id="element-696" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-697">
                  <Input type="email" placeholder="Email*" required data-id="element-698" />
                  <Input type="tel" placeholder="Phone*" required data-id="element-699" />
                </div>

                <div className="relative" data-id="element-700">
                  <select className="flex h-11 w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm font-body text-gray-900 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF1493] focus-visible:border-[#FF1493] appearance-none cursor-pointer" defaultValue="" required data-id="element-701">
                    <option value="" disabled hidden data-id="element-702">
                      Select Your Treatment of Interest*
                    </option>
                    <option value="body" data-id="element-703">Body Contouring</option>
                    <option value="skin" data-id="element-704">Skin Services</option>
                    <option value="laser" data-id="element-705">Laser Treatments</option>
                    <option value="injectables" data-id="element-706">Injectables</option>
                    <option value="medical" data-id="element-707">Medical Treatments</option>
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={16} data-id="element-708" />
                </div>

                <Textarea placeholder="Your message" className="min-h-[100px]" data-id="element-709" />

                <div className="flex items-start gap-3 pt-2" data-id="element-710">
                  <input type="checkbox" id="consent" className="mt-1 h-4 w-4 rounded border-gray-300 text-[#FF1493] focus:ring-[#FF1493]" data-id="element-711" />
                  <label htmlFor="consent" className="text-xs text-gray-500 leading-relaxed font-[Poppins,_sans-serif]" data-id="element-712">
                    By submitting this form, I agree to the{' '}
                    <a href="#" className="underline hover:text-[#FF1493]" data-id="element-713">
                      Privacy Policy
                    </a>{' '}
                    for Be CLINICAL and consent to receive marketing text
                    messages and emails from Be CLINICAL. Consent is not a
                    condition of any purchase. Message and data rates may apply.
                    Message frequency varies. You can unsubscribe at any time by
                    replying STOP or clicking the unsubscribe link in one of our
                    messages.
                  </label>
                </div>

                <div className="flex justify-center pt-6" data-id="element-714">
                  <Button type="submit" variant="primary" size="lg" className="px-12 py-4 text-base tracking-[0.15em]" data-id="element-715">
                    SUBMIT
                  </Button>
                </div>
              </form>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}